import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminHeader from "../../layouts/admin-header";
import AdminFooter from "../../layouts/admin-footer";
import AdminNavBar from "../../layouts/admin-nav-bar";
import Loader from "../../loader";
import { API_URL } from "../../../config/constant";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function GeneralContactLists({ menuAccess }) {
  const [contacts, setContacts] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchContacts = async () => {
    try {
        
      const res = await axios.get(API_URL + "contact/list");
      setContacts(res.data.data);
    } catch (error) {
      console.error("Failed to fetch contacts");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const downloadExcel = () => {
    if (!contacts.length) return;

    const formattedData = contacts.map((row) => ({
      Name: row.name,
      "Mobile Number": row.mobile_number,
      "Email ID": row.email,
      "Loan Type": row.loan_type,
      "Created Date": new Date(row.created_at).toLocaleDateString(),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, `contact_leads_${new Date().toISOString()}.xlsx`);
  };

  return (
  <>
    {loader && <Loader />}

    <div className="layout-wrapper">
      <div className="layout-container">
        <AdminNavBar menuAccess={menuAccess} />

        <div className="adminMain-wrapper">
          <AdminHeader />

          <div className="mainContent">
            <div className="topHeadings" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <h3 style={{margin:"10px 0px"}}>Contact Leads</h3>
              <button
                onClick={downloadExcel}
                className="btn btn-success"
                disabled={!contacts.length}
              >
                Download Excel
              </button>
            </div>

            <div className="contentBlocks">
              <div className="sectionTable">
                <div className="continer-fluid">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12">
                      <div className="card tableLead">
                        <div className="tableLeadCase">
                            {/* Table */}
                          <table
                            style={{ width: "100%" }}
                            className="table table-stripped"
                          >
                            <thead>
                              <tr>
                                <th className="table-head">Name</th>
                                <th className="table-head">Mobile Number</th>
                                <th className="table-head">Email ID</th>
                                <th className="table-head">Loan Type</th>
                                <th className="table-head">Created Date</th>
                              </tr>
                            </thead>

                            <tbody>
                              {contacts.length === 0 ? (
                                <tr>
                                  <td colSpan="7" style={{ textAlign: "center" }}>
                                    No Leads Found
                                  </td>
                                </tr>
                              ) : (
                                contacts.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={{ borderBottom: "1px solid #ddd" }}
                                  >
                                    <td className="table-body">{row.name}</td>
                                    <td className="table-body">{row.mobile_number}</td>
                                    <td className="table-body">{row.email}</td>
                                    <td className="table-body">{row.loan_type}</td>
                                    {/*<td className="table-body">{row.utm_source}</td>*/}
                                    <td className="table-body">
                                      {new Date(row.created_at).toLocaleDateString()}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                          

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  </>
);
}